import { createSlice } from "@reduxjs/toolkit";

import {
  createCustomFieldDefinition,
  deleteCustomFieldDefinition,
  fetchCustomFieldDefinitions,
  reorderCustomFieldDefinitions,
  updateCustomFieldDefinition,
} from "./customFieldsActions";

export const initialState = {
  definitionsByEntityType: {},
  isLoading: false,
  error: null,
};

const customFieldsSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomFieldDefinitions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomFieldDefinitions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.definitionsByEntityType[payload.entityType] = payload.definitions;
      })
      .addCase(fetchCustomFieldDefinitions.rejected, (state, { error }) => {
        state.isLoading = false;
        state.error = error.message ?? null;
      })
      .addCase(createCustomFieldDefinition.fulfilled, (state, { payload }) => {
        const existing =
          state.definitionsByEntityType[payload.entityType] ?? [];
        state.definitionsByEntityType[payload.entityType] = [
          ...existing,
          payload.definition,
        ];
      })
      .addCase(updateCustomFieldDefinition.fulfilled, (state, { payload }) => {
        const defs = state.definitionsByEntityType[payload.entityType] ?? [];
        state.definitionsByEntityType[payload.entityType] = defs.map((d) =>
          d.id === payload.definition.id ? payload.definition : d
        );
      })
      .addCase(deleteCustomFieldDefinition.fulfilled, (state, { payload }) => {
        state.definitionsByEntityType[payload.entityType] = (
          state.definitionsByEntityType[payload.entityType] ?? []
        ).filter((d) => d.id !== payload.fieldId);
      })
      .addCase(
        reorderCustomFieldDefinitions.fulfilled,
        (state, { payload }) => {
          state.definitionsByEntityType[payload.entityType] =
            payload.definitions;
        }
      );
  },
});

export default customFieldsSlice.reducer;
